/**
 * Map Editor Status Bar — coordinates, zoom level, item counts
 */

import { useMapEditor } from '../MapEditorProvider';

export function StatusBar() {
  const { state } = useMapEditor();
  const { cursorPosition, photos, floorPlans, selectedIds } = state;

  return (
    <div style={styles.bar}>
      <div style={styles.left}>
        {cursorPosition ? (
          <span style={styles.coords}>
            Lng: {cursorPosition.lng.toFixed(6)} &nbsp; Lat: {cursorPosition.lat.toFixed(6)}
          </span>
        ) : (
          <span style={styles.coords}>Move cursor over map</span>
        )}
      </div>
      <div style={styles.right}>
        {selectedIds.length > 0 && (
          <span style={styles.stat}>{selectedIds.length} selected</span>
        )}
        <span style={styles.stat}>{photos.length} photo{photos.length !== 1 ? 's' : ''}</span>
        <span style={styles.stat}>{floorPlans.length} overlay{floorPlans.length !== 1 ? 's' : ''}</span>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  bar: {
    height: 28,
    background: 'rgba(13,13,13,0.95)',
    borderTop: '1px solid #333',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 12px',
    flexShrink: 0,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  coords: {
    fontSize: 11,
    fontFamily: 'monospace',
    color: '#64748b',
  },
  stat: {
    fontSize: 11,
    color: '#475569',
  },
};
